import React, { Component } from "react";
import classnames from 'classnames';
import { eapiClient, taxonomyHostClient } from '../../../restClient';
import { setLanguageFlag } from '../../layouts/actions/actionCreator';

//child
import CheckBox from "./CheckBox";

import './style.css';

class NestedCheckBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country: [],
      checkBoxInvalid: false,
    };
  }

  componentDidMount() {
    this.fetchResources(this.props.resourceUrl)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCaseId !== this.props.selectedCaseId) {
      let country = [...this.state.country];
      country.forEach(item => item.isChecked = false);
      this.props.getValues([]);
      this.validateCheckbox();
    }

    if (this.props.resourceUrl !== nextProps.resourceUrl) {
      this.fetchResources(nextProps.resourceUrl);
    }
  }

  setValue = (item, event) => {
    if (item.id === event.target.id) {
      item.isChecked = event.target.checked;
      return item;
    }
  }

  fetchResources = (resourcesUrl) => {
    if (resourcesUrl !== undefined) {
      taxonomyHostClient(resourcesUrl)
        .then(({ data }) => {
          this.setState({
            country: data.responseData.classificationNodes
          })
        });
    }
  }

  filterResult = (data, isChecked = true) => {
    if (isChecked === false) {
      return data.filter(item => !item.isChecked)
    }
    return data.filter(item => item.isChecked)
  }

  validateCheckbox = () => {
    if (this.props.mandatory === "true") {
      let _country = this.state.country;
      if (this.props.achCreditProductList !== undefined) {
        for (let i = 0; i < _country.length; i++) {
          if (_country[i].isChecked && _country[i].associations.length > 0) {
            _country[i].associations.some((acc) => {
              if (acc.isChecked) {
                this.setState({ checkBoxInvalid: false });
                this.props.setFieldValidtionState(this.props.name, "valid");
                return true;
              }
              else {
                return false;
              }
            })
            break;
          } else if (_country[i].isChecked && _country[17].isChecked === false) {
            this.setState({ checkBoxInvalid: false });
            this.props.setFieldValidtionState(this.props.name, "valid");
            break;
          } else if (_country[i].isChecked && _country[18].isChecked === false) {
            this.setState({ checkBoxInvalid: false });
            this.props.setFieldValidtionState(this.props.name, "valid");
            break;
          } else {
            this.setState({ checkBoxInvalid: true });
            this.props.setFieldValidtionState(this.props.name, "invalid");
          }
        }
      }
      else {
        let isChecked = _country.filter(item => item.isChecked === true).length;
        if (isChecked > 0) {
          this.setState({ checkBoxInvalid: false });
          this.props.setFieldValidtionState(this.props.name, "valid");
        }
        else {
          this.setState({ checkBoxInvalid: true });
          this.props.setFieldValidtionState(this.props.name, "invalid");
        }
      }
    }
  }

  handleCheckElement = event => {
    let country = [...this.state.country];
    country.forEach(item => this.setValue(item, event));
    this.setState({ country: country }, () => {
      this.validateCheckbox()
      this.props.getValues(this.filterResult(this.state.country));
    });
  };

  handleSubCheckbox = event => {
    let country = this.state.country;
    country.forEach(item =>
      item.associations.forEach(sub => this.setValue(sub, event))
    );
    this.setState({ country: country }, () => {
      this.validateCheckbox()
      this.props.getValues(this.filterResult(this.state.country))
    });
  };

  getDisabledData = () => {
    if (Array.isArray(this.props.productList) && this.props.productList.length) {
      return this.props.productList
    }
    return []
  }

  render() {
    const { country } = this.state;
    const isAssociation = this.props.isAssociation === undefined ? true : this.props.isAssociation;
    const checkBoxCss = classnames({
      "gdocs-input-error": this.state.checkBoxInvalid === true
    });
    return (
      <div>
        <div className="checkboxes">
          {country !== undefined &&
            country.length > 0 && this.props.achCreditProductList !== undefined ?
            country.map((opt, i) => (
              <CheckBox
                {...opt}
                key={i}
                handleCheckElement={this.handleCheckElement}
                handleSubCheckbox={this.handleSubCheckbox}
                disabledData={[]}
                selectedCaseId={this.props.selectedCaseId}
                isAssociation={isAssociation}
                isCType={false}
              />
            ))
            :
            country.map((opt, i) => (
              <CheckBox
                {...opt}
                key={i}
                handleCheckElement={this.handleCheckElement}
                handleSubCheckbox={this.handleSubCheckbox}
                disabledData={this.getDisabledData()}
                selectedCaseId={this.props.selectedCaseId}
                isAssociation={isAssociation}
                isCType={true}
                productType={this.props.productType ? this.props.productType : undefined}
                selectedCheckBox={this.filterResult(this.state.country)}
              />
            ))
          }
        </div>
        <p className={checkBoxCss}>
          {
            this.state.checkBoxInvalid ? (
              <div className="input-error-msg-section">
                <span className="icon icon-circle-delete-solid"></span>{this.props.mandatoryMessage}
              </div>
            ) : ''
          }
        </p>
      </div>
    );
  }
}

export default NestedCheckBox;



// WEBPACK FOOTER //
// ./src/components/common/NestedCheckBox/NestedCheckBox.js